import React, { createContext, useState, useContext, ReactNode, useEffect } from 'react';

interface AddProductType {
  product: any;
  setProduct: (value: any) => void;
  category: any;
  setCategory: (value: any) => void;
  showAddProduct: boolean;
  setShowAddProduct: (value: boolean) => void;
  redirectToProductSlug: any;
  setRedirectToProductSlug: (value: string) => void;
  compositeProductBlocked: boolean;
  setCompositeProductBlocked: (value: boolean) => void;
  loadingCallWaiter: boolean;
  setLoadingCallWaiter: (value: boolean) => void;
}

const AddProductContext = createContext<AddProductType | undefined>(undefined);

export const AddProductProvider = ({ children }: { children: ReactNode }) => {
  const [showAddProduct, setShowAddProduct] = useState(false);
  const [product, setProduct] = useState(null);
  const [category, setCategory] = useState(null);
  const [redirectToProductSlug, setRedirectToProductSlug] = useState(() => localStorage.getItem('redirect_product_slug') || null);
  const [compositeProductBlocked, setCompositeProductBlocked] = useState(false);
  const [loadingCallWaiter, setLoadingCallWaiter] = useState(false);

  useEffect(() => {
    if (redirectToProductSlug) {
      localStorage.setItem('redirect_product_slug', redirectToProductSlug)
    } else {
      localStorage.removeItem('redirect_product_slug')
    }
  }, [redirectToProductSlug]);

  // Aguardando produto e categoria para abrir modal do produto
  useEffect(() => {
    if (product && category) {
      setShowAddProduct(true);
    }
  }, [product, category])

  useEffect(() => {
    if (!showAddProduct) {
      setRedirectToProductSlug('');
    }
  }, [showAddProduct])

  return (
    <AddProductContext.Provider value={{
        showAddProduct, setShowAddProduct,
        product, setProduct,
        category, setCategory,
        redirectToProductSlug, setRedirectToProductSlug,
        compositeProductBlocked, setCompositeProductBlocked,
        loadingCallWaiter, setLoadingCallWaiter
      }}>
      {children}
    </AddProductContext.Provider>
  );
};

export const useAddProductContext = () => {
  const context = useContext(AddProductContext);
  if (!context) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
};
